module.exports = new __parcel__URL__("seahorse-ios7.b87dc9cf.png").toString();